
class SystemGenericModal {

    Id = null;
    _element = null;
    Istance = null;

    constructor(selector) {
        this.Id = selector;
        this._element = document.getElementById(this.Id);

    }

    HideHandler(event) {
        const icona = this._element.querySelector('#systemMessageModalIcon');
        const titolo = this._element.querySelector('#systemMessageModalTitle');
        const mess = this._element.querySelector('#systemMessageModalMessage');
        icona.setAttribute('class', '');
        titolo.textContent = '';
        mess.textContent = '';
    }

    ShowHandler(event) {

    }

    shownHandler(event) {

    }


    Build(title
        , message
        , type
        , hideAutomaticallyAfterMilliseconds = -1
        , showSuccessButton = false
        , successText = "OK"
        , successCallback = null
        , showDangerButton = false
        , dangerText = ""
        , dangerCallback = null
        , showNeutralButton = true
        , neutralText = "Chiudi"
        , neutralCallback = null) {
        try {

            const icona = this._element.querySelector('#systemMessageModalIcon');
            const titolo = this._element.querySelector('#systemMessageModalTitle');
            const mess = this._element.querySelector('#systemMessageModalMessage');
            icona.setAttribute('class', '');
            switch (type) {
                case 'success':
                    icona.classList.add('fs-1', 'bi', 'bi-check-square-fill', 'text-success');
                    break;
                case 'warning':
                    icona.classList.add('fs-1', 'bi', 'bi-exclamation-circle-fill', 'text-warning');
                    break;
                case 'danger':
                    icona.classList.add('fs-1', 'bi', 'bi-x-square-fill', 'text-danger');
                    break;
                default:
                    icona.classList.add('fs-1', 'bi', 'bi-exclamation-circle-fill', 'text-warning');
                    break;
            }
            titolo.textContent = title;


            let MsgToPrint = '';
            if (typeof (message) == 'object') { MsgToPrint = message.message; }
            else { MsgToPrint = message; }

            if (/<[a-z][\s\S]*>/i.test(MsgToPrint)) {
                mess.innerHTML = MsgToPrint;
            } else {
                mess.textContent = MsgToPrint;
            }
            //systemMessageModal.show();

            this.configureSuccessButton(showSuccessButton, successText, successCallback);
            this.configureDangerButton(showDangerButton, dangerText, dangerCallback);
            this.configureNeutralButton(showNeutralButton, neutralText, neutralCallback);

            var progressCircleContainer = document.getElementById('countdown-progress-circle-container');
            if (hideAutomaticallyAfterMilliseconds && hideAutomaticallyAfterMilliseconds > -1) {
                if (progressCircleContainer) {
                    progressCircleContainer.classList.remove('d-none');
                    var progressCircleElement = document.getElementById('countdown-progress-circle-container-progress');
                    var progressCountdownElement = document.getElementById('countdown-progress-circle-container-countdown');
                    this.startProgressCircleCountdown(progressCircleElement, progressCountdownElement, hideAutomaticallyAfterMilliseconds / 1000);
                }
                setTimeout(() => {
                    application.ModalManagerIstance.hide(application.SystemGenericModalIstance.Id);
                }, hideAutomaticallyAfterMilliseconds);
            } else {
                if (progressCircleContainer) {
                    progressCircleContainer.classList.add('d-none');
                }
            }

        } catch (e) {
            console.log('[DEBUG] handleSystemMessageModalOpen: ', e);
        }
    }

    configureSuccessButton(showSuccessButton, successText, successCallback) {
        var successButton = document.getElementById('systemMessageModalSuccessButton');
        if (showSuccessButton == true) {

            const newSuccesssButton = successButton.cloneNode(true);
            successButton.parentNode.replaceChild(newSuccesssButton, successButton);
            successButton = document.getElementById('systemMessageModalSuccessButton');

            successButton.classList.remove('d-none');
            if (successText == null || successText == '')
                throw new Error('SuccessText non può essere null o vuoto');
            successButton.textContent = successText;
            successButton.addEventListener('click', function () {
                if (successCallback != null) {
                    successCallback();
                }
                application.ModalManagerIstance.hide(application.SystemGenericModalIstance.Id);
            });
        } else {
            successButton.classList.add('d-none');
        }

    }

    configureDangerButton(showDangerButton, dangerText, dangerCallback) {
        var dangerButton = document.getElementById('systemMessageModalErrorButton');
        if (showDangerButton == true) {
            const newDangerButton = dangerButton.cloneNode(true);
            dangerButton.parentNode.replaceChild(newDangerButton, dangerButton);
            dangerButton = document.getElementById('systemMessageModalErrorButton');
            dangerButton.classList.remove('d-none');
            if (dangerText == null || dangerText == '')
                throw new Error('dangerText non può essere null o vuoto');
            dangerButton.textContent = dangerText;

            dangerButton.addEventListener('click', function () {
                if (dangerCallback != null) {
                    dangerCallback();
                }
                application.ModalManagerIstance.hide(application.SystemGenericModalIstance.Id);
            });

        } else {
            dangerButton.classList.add('d-none');
        }
    }

    configureNeutralButton(showNeutralButton, neutralText, neutralCallback) {
        var neutralButton = document.getElementById('systemMessageModalNeutralButton');
        if (showNeutralButton == true) {
            const newNeutralButton = neutralButton.cloneNode(true);
            neutralButton.parentNode.replaceChild(newNeutralButton, neutralButton);
            neutralButton = document.getElementById('systemMessageModalNeutralButton');
            neutralButton.classList.remove('d-none');
            if (neutralText == null || neutralText == '') {
                throw new Error('neutralText non può essere null o vuoto');
            }
            neutralButton.textContent = neutralText;
            neutralButton.addEventListener('click', function () {
                if (neutralCallback != null) {
                    neutralCallback();
                }
                application.ModalManagerIstance.hide(application.SystemGenericModalIstance.Id);
            });
        } else {
            neutralButton.classList.add('d-none');
        }
    }


    startProgressCircleCountdown(progressCircleElement, countDownTextElement, seconds) {
        let countdownValue = seconds; // Numero di secondi per il countdown    
        countDownTextElement.textContent = seconds;
        const totalLength = 63; // Circonferenza del cerchio (2 * pi greco * raggio)
        progressCircleElement.style.strokeDashoffset = totalLength;
        progressCircleElement.style.dashoffset = totalLength;
        let interval = setInterval(() => {
            countdownValue--;
            countDownTextElement.textContent = countdownValue;
            // Calcola la percentuale rimanente del countdown e aggiorna l'offset del cerchio
            const progress = (countdownValue / seconds) * totalLength;
            progressCircleElement.style.strokeDashoffset = progress;

            // Ferma il countdown quando raggiunge zero
            if (countdownValue <= 0) {
                clearInterval(interval);
                countDownTextElement.innerText = "0";
            }
        }, 1000);
    }
}

